// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button } from "../../../revvComponents";

import {
  updateComponentMeta,
  updateDocumentClickedComponentID,
} from "../../../actions/DocumentActions/index";

// Internal imports
import { convertLinkedQuotetoTable } from "../utils";

class TableToQuoteUnlinkPopup extends Component {
  state = {};

  _closePopup = () => {
    this.props.updateMultipleState({
      showTabletoQuoteUnlink: false,
    });
  };

  _handleConfirmation = () => {
    this.props.updateComponentMeta({});
    this.props.updateDocumentClickedComponentID(null, true, null);
    const updatedTableData = convertLinkedQuotetoTable(
      this.props.currentSection,
    );
    this.props.saveTable(updatedTableData);
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="modal-container table-gsheet-popup-container"
          data-test="table-gsheet-popup-container">
          <div
            className="modal-heading table-gsheet-unlink-heading"
            data-test="table-gsheet-popup-modal-heading">
            <span role="img" aria-label="">
              ⚠️
            </span>{" "}
            <span>You&apos;re about to unlink the Quote table</span>
          </div>
          <div className="modal-form">
            <div
              className="modal-form-field"
              data-test="table-gsheet-popup-form">
              If you unlink the Quote table, the data that is already synced
              will remain. However, you will no longer be able to sync live
              changes made in the Quote table with this Revv table.
            </div>
          </div>

          <div className="modal-footer">
            <Button
              type="five"
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="table-gsheet-popup-cancle-btn"
              onClick={this._closePopup}>
              Go back
            </Button>
            <Button
              type="four"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="table-gsheet-popup-submit-btn"
              onClick={() => this._handleConfirmation()}>
              Unlink anyway
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { isGoogleSheetAuthenticated, activeComponentMeta, components } =
    state.DocumentStore;

  return {
    currentSection: components[activeComponentMeta.componentId],
    isGoogleSheetAuthenticated,
  };
};

const mapDispatchToProps = {
  updateComponentMeta,
  updateDocumentClickedComponentID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableToQuoteUnlinkPopup);
